import { schema } from 'normalizr';

const savedWorkoutSetExerciseSchema = new schema.Entity(
    'addedSetExercises',
    {},
    {
        idAttribute: entity => entity.saved_workout_set_exercise_id
    }
);

export default savedWorkoutSetExerciseSchema;



// WEBPACK FOOTER //
// ./src/state/reducer/savedWorkoutSetExercise/schema.js